import { createSlice } from "@reduxjs/toolkit";

interface ListState {
  selectMode: "single" | "multiple";
  maxSelectCount: number;
  selectedItems: string[];
}

interface GroupOperationsState {
  [key: string]: ListState;
  tables: ListState;
}

const initialState: GroupOperationsState = {
  tables: {
    selectMode: "multiple", // single, multiple
    maxSelectCount: -1,
    selectedItems: [],
  },
};

const groupOperationsSlice = createSlice({
  name: "groupOperations",
  initialState,
  reducers: {
    setSelectMode: (state, { payload: { listId, selectMode } }) => {
      state[listId].selectMode = selectMode;
    },
    select: (state, { payload: { listId, itemIds } }) => {
      const list = state[listId] || { selectedItems: [] };
      if (list.selectMode === "single") {
        list.selectedItems = [itemIds[0]];
      } else {
        list.selectedItems = [...new Set([...list.selectedItems, ...itemIds])];
      }
    },
    deselect: (state, { payload: { listId, itemIds } }) => {
      const list = state[listId] || { selectedItems: [] };
      if (list.selectMode === "single") {
        list.selectedItems = [];
      } else {
        list.selectedItems = list.selectedItems.filter(
          (id) => !itemIds.includes(id)
        );
      }
    },
    toggle: (
      state,
      {
        payload: {
          listId,
          itemIds: [itemId],
        },
      }
    ) => {
      const list = state[listId] || { selectedItems: [] };

      if (list.selectMode === "multiple") {
        list.selectedItems = [...new Set([...list.selectedItems, itemId])];
      } else {
        list.selectedItems = list.selectedItems.length === 0 ? [itemId] : [];
      }
    },
    selectAll: (state, { payload: { listId, itemIds } }) => {
      const list = state[listId] || { selectedItems: [] };
      list.selectedItems = itemIds;
    },
    clear: (state, { payload: { listId } }) => {
      const list = state[listId] || { selectedItems: [] };
      list.selectMode = "single";
      list.selectedItems = [];
    },
  },
});

export const { select, deselect, toggle, selectAll, clear } =
  groupOperationsSlice.actions;
export default groupOperationsSlice.reducer;
